import { EditCashbackAllocationsModal } from 'core/Components';

import {
  ModalTitleWithBackButton,
  useDonationSettingModalProvider,
} from '../DonationSettingsModalProvider';

const EditCashbackAllocationModal = () => {
  const { opened, close } = useDonationSettingModalProvider({
    id: 'EditAllocation',
  });
  return (
    <EditCashbackAllocationsModal
      opened={opened}
      onClose={close}
      title={<ModalTitleWithBackButton>Edit Cashback Allocation</ModalTitleWithBackButton>}
    />
  );
};

export { EditCashbackAllocationModal };
